import { objectTypeTypeGuard } from '../types.js';
import { TypeService } from '../services/TypeService.js';
export class ExternalFieldCyclicDependenciesValidator {
    constructor(objectType, schema) {
        this.objectType = objectType;
        this.schema = schema;
        this.typeService = new TypeService(objectType.getTypeReference(), schema);
    }
    validate() {
        for (let externalField of this.objectType.externals) {
            this.validateCyclicDependency(externalField);
        }
    }
    validateCyclicDependency(externalField) {
        const externalFieldName = externalField.name;
        for (let property of externalField.properties) {
            const visitedExternals = new Set([]);
            const q = [property];
            while (q.length) {
                const nextProperty = q.pop();
                const propertyTypeExternalField = this.getExternalField(nextProperty);
                if (!propertyTypeExternalField) {
                    continue;
                }
                if (visitedExternals.has(nextProperty)) {
                    throw new Error(`Cyclic dependency detected for "${externalFieldName}". Check ${property} property`);
                }
                q.push(...propertyTypeExternalField.properties);
                visitedExternals.add(nextProperty);
            }
        }
    }
    getExternalField(propertyPath) {
        const { parent, child: propertyName } = TypeService.getParentChildPath(propertyPath);
        const nestedType = this.typeService.getPropertyType(parent);
        if (objectTypeTypeGuard(nestedType)) {
            return nestedType.externals.find(external => external.name === propertyName);
        }
        return null;
    }
}
//# sourceMappingURL=ExternalFieldCyclicDependenciesValidator.js.map